import { Routes } from '@angular/router';
import { Auth } from './auth/auth';
import { AuthGuard } from './auth/auth.guard';
import { ForgotPassword } from './auth/forgot-password/forgot-password';
import { ImpersonationGuard } from './auth/impersonation.guard';
import { LoginGuard } from './auth/login.guard';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { CompanyProfileComponent } from './company-profile/company-profile.component';
import { EditCompanyComponent } from './company-profile/edit-company/edit-company.component';
import { DownloadsComponent } from './downloads/downloads.component';
import { HomeTilesComponent } from './home-tiles/home-tiles.component';
import { ImpersonationComponent } from './impersonation/impersonation.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { ChangePasswordComponent } from './my-profile/change-password/change-password.component';
import { EditProfileComponent } from './my-profile/edit-profile/edit-profile.component';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { RoutesConst } from './shared/route-const';
import { TutorialsComponent } from './tutorials/tutorials.component';
import { AddUserComponent } from './user-management/add-user/add-user.component';
import { UserManagementComponent } from './user-management/user-management.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: RoutesConst.home,
    pathMatch: 'full',
  },

  // Public / Auth area: hide sidebar

  {
    path: RoutesConst.login,
    component: Auth,
    canActivate: [LoginGuard],
    data: { showSideNav: false },
    children: [
      {
        path: RoutesConst.forgotPassword,
        component: ForgotPassword,
        data: { showSideNav: false },
      },
      {
        path: RoutesConst.activateAccount,
        component: ForgotPassword,
        data: { showSideNav: false },
      },
      {
        path: RoutesConst.resetPassword,
        component: ResetPasswordComponent,
        data: { showSideNav: false },
      },
    ],
  },
  {
    path: RoutesConst.logout,
    component: Auth,
    pathMatch: 'full',
    data: { showSideNav: false },
  },

  // Protected area: show sidebar (componentless parent, NO additional outlet)
  {
    path: '',
    canActivate: [AuthGuard],
    data: { showSideNav: true },
    children: [
      { path: RoutesConst.home, component: HomeTilesComponent },

      // My Profile (flat routes instead of children -> no additional outlet required)
      { path: RoutesConst.myProfile, component: MyProfileComponent },
      { path: `${RoutesConst.myProfile}/${RoutesConst.edit}`, component: EditProfileComponent },
      { path: `${RoutesConst.myProfile}/${RoutesConst.changePassword}`, component: ChangePasswordComponent },

      // Company Profile
      { path: RoutesConst.companyProfile, component: CompanyProfileComponent },
      { path: `${RoutesConst.companyProfile}/${RoutesConst.edit}`, component: EditCompanyComponent },

      // User Management
      { path: RoutesConst.manageUsers, component: UserManagementComponent },
      { path: `${RoutesConst.manageUsers}/${RoutesConst.add}`, component: AddUserComponent },
      // impersonation
      {
        path: RoutesConst.impersonation,
        component: ImpersonationComponent,
        canActivate: [ImpersonationGuard],
      },
      // other routes on home-tiles
      { path: RoutesConst.downloads, component: DownloadsComponent },
      { path: RoutesConst.maintenance, component: MaintenanceComponent },
      { path: RoutesConst.tutorials, component: TutorialsComponent },
    ],
  },

  { path: '**', redirectTo: RoutesConst.home },
];
